export default __webpack_public_path__ + "static/media/logo.d2340fa3.png";